/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  addDoc,
  collection,
  doc,
  updateDoc,
  arrayRemove,
} from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import Select from "react-select";
import { serverTimestamp } from "firebase/firestore";

const ModalAdd = ({ lgShow, setLgShow, dataForm, setDataForm, onSave }) => {
  const { t: uiT } = useUiTranslation();
  const products = useSelector((state) => state.ProductsReducer);
  const setting = useSelector((state) => state.StoreReducer);
  const [showSubmenus, setShowSubmenus] = useState({});
  const [formItems, setFormItems] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (let i = 0; i < formItems.length; i++) {
      const item = formItems[i];
      if (!item.name || item.name === "" || item.price <= 0) {
        await Swal.fire({
          title: uiT("error"),
          text: uiT("ui.productPriceRequired"),
          icon: "error",
          confirmButtonText: uiT("common.ok"),
          confirmButtonColor: "#8d5da7",
        });
        return;
      }
    }

    const updatedProducts = [...dataForm?.products, ...formItems];
    const finalTotal =
      updatedProducts?.reduce((acc, item) => {
        return acc + item.price * item.quantity;
      }, 0) + parseFloat(dataForm.deliveryPrice || 0);
    const { timeStamp, statusTimeline, ...otherFields } = dataForm;

    const updatedDataForm = {
      ...otherFields,
      products: updatedProducts,
      total: finalTotal,
    };

    if (!dataForm.id) {
      await addDoc(collection(db, "orders"), {
        ...updatedDataForm,
        timeStamp: serverTimestamp(),
      });
    } else {
      await updateDoc(doc(db, "orders", dataForm.id), updatedDataForm);
    }
    if (typeof onSave === "function") {
      onSave(updatedDataForm);
    }
    setLgShow(false);
    setFormItems([]);
  };

  const toggleSubmenu = (productId) => {
    setShowSubmenus((prevShowSubmenus) => ({
      ...prevShowSubmenus,
      [productId]: !prevShowSubmenus[productId],
    }));
  };

  const addFormItem = () => {
    setFormItems([
      ...formItems,
      {
        image: "",
        name: "",
        options: { offer: "", color: "", size: "" },
        price: 0,
        quantity: 1,
        sku: "",
      },
    ]);
  };

  const handleChange = (index, field, value) => {
    const newFormItems = [...formItems];

    if (field === "productId") {
      const selectedProduct = products.find((product) => product.id === value);
      if (selectedProduct) {
        newFormItems[index] = {
          ...newFormItems[index],
          name: selectedProduct.name,
          image: selectedProduct.image,
          price: parseInt(selectedProduct.price),
          sku: selectedProduct.sku,
        };
      }
    } else if (field.startsWith("options.")) {
      const optionField = field.split(".")[1];

      newFormItems[index] = {
        ...newFormItems[index],
        options: {
          ...newFormItems[index].options,
          [optionField]: value,
        },
      };
    } else {
      newFormItems[index] = {
        ...newFormItems[index],
        [field]: value,
      };
    }

    setFormItems(newFormItems);
  };

  useEffect(() => {
    // حساب مجموع أسعار المنتجات الموجودة في formItems
    const currentItemsTotal = formItems?.reduce((acc, item) => {
      return acc + item.price * item.quantity;
    }, 0);

    // حساب مجموع أسعار المنتجات الموجودة مسبقًا في dataForm?.products
    const previousItemsTotal = dataForm?.products?.reduce((acc, product) => {
      return acc + product.price * product.quantity;
    }, 0);

    // حساب السعر الإجمالي
    const total =
      currentItemsTotal +
      previousItemsTotal +
      parseFloat(dataForm.deliveryPrice || 0);

    // تحديث total في dataForm
    setDataForm((prevDataForm) => ({
      ...prevDataForm,
      total,
    }));
  }, [formItems, dataForm?.products, dataForm.deliveryPrice]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
  };

  const options = products.map((product) => ({
    value: product.id,
    label: (
      <div className="flex items-center">
        <img
          src={product.image || ""}
          className="w-6 h-6 rounded-full mr-2"
          alt={uiT("ship.product")}
        />
        {product.name}
      </div>
    ),
  }));

  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...dataForm.products];

    // Ensure quantity is at least 1
    if (field === "quantity" && value < 1) {
      value = 1;
    }

    if (field.startsWith("options.")) {
      const optionField = field.split(".")[1];
      updatedProducts[index].options[optionField] = value;
    } else {
      updatedProducts[index][field] = value;
    }

    setDataForm({
      ...dataForm,
      products: updatedProducts,
    });
  };
  // ! this for TEST
  // const handleButtonClick = () => {
  //   console.log("Form Items State:", formItems);
  //   alert(JSON.stringify(formItems, null, 2));
  // };
  const handleEditProduct = (product, index) => {
    Swal.fire({
      title: uiT("ui.editProduct"),
      html: `
        <select id="swal-select" class="swal2-input">
          <option value="">اختر المنتج</option>
          ${products
            .map(
              (p) => `
            <option value="${p.id}" ${p.id === product.id ? "selected" : ""}>
              ${p.name}
            </option>
          `
            )
            .join("")}
        </select>
        <input id="swal-input1" class="swal2-input" value="${
          product?.options?.color
        }" placeholder="اللون">
        <input id="swal-input2" class="swal2-input" value="${
          product?.options?.size
        }" placeholder="الحجم">
        <input id="swal-input3" class="swal2-input" value="${
          product?.options?.offer
        }" placeholder="العرض">
        <input id="swal-input4" class="swal2-input" value="${
          product.quantity
        }" type="number" placeholder="الكمية">
        <input id="swal-input5" class="swal2-input" value="${
          product.price
        }" type="number" placeholder="السعر">
      `,
      focusConfirm: false,
      didOpen: () => {
        document.getElementById("swal-input1").focus();
      },
      preConfirm: () => {
        const selectedProductId = document.getElementById("swal-select").value;
        const selectedProduct =
          products.find((p) => p.id === selectedProductId) || product;

        return {
          id: selectedProduct.id,
          name: selectedProduct.name,
          image: selectedProduct.image,
          sku: selectedProduct.sku,
          color: document.getElementById("swal-input1").value,
          size: document.getElementById("swal-input2").value,
          offer: document.getElementById("swal-input3").value,
          quantity: parseInt(document.getElementById("swal-input4").value),
          price: parseFloat(document.getElementById("swal-input5").value),
        };
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedProduct = {
          ...product,
          id: result.value.id,
          name: result.value.name,
          image: result.value.image,
          sku: result.value.sku,
          options: {
            ...product.options,
            color: result.value.color,
            size: result.value.size,
            offer: result.value.offer,
          },
          quantity: parseInt(result.value.quantity),
          price: parseFloat(result.value.price),
        };

        const updatedProducts = [...dataForm.products];
        updatedProducts[index] = updatedProduct;

        setDataForm({
          ...dataForm,
          products: updatedProducts,
        });
      }
    });
  };

  const handleDecrease = () => {
    onQuantityChange(quantity - 1);
  };

  const handleIncrease = () => {
    onQuantityChange(quantity + 1);
  };
  const [quantity, setQuantity] = useState(0);

  const handleQuantityChange = (newQuantity) => {
    setQuantity(newQuantity < 0 ? 0 : newQuantity); // Prevent negative values
  };

  return (
    <Modal
      size="lg"
      show={lgShow}
      onHide={() => setLgShow(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      dir="rtl"
      className="w-100"
    >
      {!!setting.id && (
        <Form onSubmit={handleSubmit}>
          <Modal.Header>
            <Modal.Title id="example-modal-sizes-title-lg">{uiT("orderDetails.orderForm.title")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-center text-white fr-b">
              <b>{uiT("orderDetails.orderForm.orderProducts")}</b>
            </p>
            {dataForm?.products && dataForm?.products.length === 0 ? (
              <div className="text-center">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/7486/7486747.png"
                  alt={uiT("orderDetails.orderForm.noDataAlt")}
                  className="w-20 h-20 mx-auto"
                />
                <br></br>
              </div>
            ) : (
              dataForm?.products &&
              dataForm?.products.map((product, index) => (
                <div className="mx-auto py-0 md:px-2 relative" key={index}>
                  <div
                    className="d-flex justify-content-between w-100 p-1-2 border4 card"
                    onClick={() => toggleSubmenu(product.name)}
                  >
                    <li className="flex gap-4 items-center">
                      <img
                        src={
                          product.image ? product.image : "/product-foorweb.png"
                        }
                        className="w-10 h-10 rounded-full"
                        alt={product.name}
                      />
                      <div className="flex-1 text-left flex items-center gap-x-1 text-truncate1">
                        {product.name}
                      </div>
                      <input
                        type="number"
                        className="text-sm"
                        value={product.price}
                        placeholder={uiT("unspecified")}
                        style={{ textAlign: "left", fontWeight: "700" }}
                        onChange={(e) =>
                          handleProductChange(index, "price", e.target.value)
                        }
                      />
                      <i
                        className={`bi ${
                          showSubmenus[product.name]
                            ? "bi-chevron-double-up"
                            : "bi-chevron-double-down"
                        }`}
                        style={{ color: "#45a788" }}
                      ></i>
                    </li>
                  </div>
                  <div
                    className={`submenu ${
                      showSubmenus[product.name] ? "open" : ""
                    }`}
                  >
                    <div className="w-100 p-1-2 border4">
                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">{uiT("offer")}</p>
                        <input
                          type="text"
                          className="w-full py-2 px-3 text-gray-500 bg-transparent outline-none border-none m-0 text-success"
                          value={product?.options?.offer}
                          placeholder={uiT("unspecified")}
                          style={{ textAlign: "left", fontWeight: "700" }}
                          onChange={(e) =>
                            handleProductChange(
                              index,
                              "options.offer",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <hr className="m-0 p-0" />
                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">{uiT("orderDetails.product_details.color")}</p>
                        <input
                          type="text"
                          className="w-full py-2 px-3 text-gray-500 bg-transparent outline-none border-none m-0 text-success"
                          value={product?.options?.color}
                          placeholder={uiT("unspecified")}
                          style={{ textAlign: "left", fontWeight: "700" }}
                          onChange={(e) =>
                            handleProductChange(
                              index,
                              "options.color",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <hr className="m-0 p-0" />
                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">{uiT("orderDetails.product_details.option")}</p>
                        <input
                          type="text"
                          className="w-full py-2 px-3 text-gray-500 bg-transparent outline-none border-none m-0 text-success"
                          value={product?.options?.size}
                          placeholder={uiT("unspecified")}
                          style={{ textAlign: "left", fontWeight: "700" }}
                          onChange={(e) =>
                            handleProductChange(
                              index,
                              "options.size",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <hr className="m-0 p-0" />
                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">{uiT("Products.Table.expand.info.quantity")}</p>
                        <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                          <div
                            onClick={() =>
                              handleProductChange(
                                index,
                                "quantity",
                                product.quantity - 1
                              )
                            }
                          >
                            <i
                              className="bi bi-dash-circle"
                              style={{ fontSize: "24px" }}
                            ></i>
                          </div>
                          <input
                            type="text"
                            className="w-full py-2 px-3 text-gray-500 bg-transparent outline-none border-none m-0 text-success"
                            value={product.quantity}
                            placeholder={uiT("unspecified")}
                            style={{
                              width: "20px",
                              textAlign: "center",
                              fontWeight: "700",
                            }}
                            onChange={(e) =>
                              handleProductChange(
                                index,
                                "quantity",
                                parseInt(e.target.value)
                              )
                            }
                          />
                          <div
                            onClick={() =>
                              handleProductChange(
                                index,
                                "quantity",
                                product.quantity + 1
                              )
                            }
                          >
                            <i
                              className="bi bi-plus-circle"
                              style={{ fontSize: "24px" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span
                    className="absolute top-0 left-0 p-1"
                    style={{
                      backgroundColor: "rgba(69, 167, 77, 0)",
                      marginTop: "-11px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // لمنع انتشار الحدث للنقرات الأخرى
                    }}
                  >
                    <i
                      className="bi bi-x-circle"
                      style={{ color: "red", fontSize: "18px" }}
                      onClick={async (e) => {
                        e.stopPropagation(); // لمنع انتشار الحدث

                        if (dataForm?.products.length + formItems.length > 1) {
                          Swal.fire({
                            title: uiT("cashBack.swal.deleteConfirm.title"),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#d33",
                            cancelButtonColor: "#6c757d",
                            confirmButtonText: uiT("ship.delete"),
                            cancelButtonText: uiT("annule"),
                          }).then(async (result) => {
                            if (result.isConfirmed) {
                              const productToRemove = product;
                              let updatedTotal = dataForm.total;

                              if (
                                dataForm?.products.some(
                                  (p) => p.name === product.name
                                )
                              ) {
                                const docRef = doc(db, "orders", dataForm.id);
                                await updateDoc(docRef, {
                                  products: arrayRemove(productToRemove),
                                });
                                const updatedProducts =
                                  dataForm?.products.filter(
                                    (p) => p.name !== product.name
                                  );

                                // تحديث total بطرح سعر المنتج المحذوف
                                updatedTotal -=
                                  product.price * product.quantity;

                                setDataForm({
                                  ...dataForm,
                                  products: updatedProducts,
                                  total: updatedTotal, // تحديث total الجديد
                                });
                              } else if (
                                formItems.some((p) => p.name === product.name)
                              ) {
                                const updatedFormItems = formItems.filter(
                                  (p) => p.name !== product.name
                                );

                                // تحديث total بطرح سعر المنتج المحذوف
                                updatedTotal -=
                                  product.price * product.quantity;

                                setFormItems(updatedFormItems);
                                setDataForm({
                                  ...dataForm,
                                  total: updatedTotal, // تحديث total الجديد
                                });
                              }

                              Swal.fire(
                                uiT("ship.delete_success"),
                                "تم حذف العنصر بنجاح.",
                                "success"
                              );
                            }
                          });
                        } else {
                          alert(uiT("orderDetails.orderForm.product.deleteLastProductWarning"));
                        }
                      }}
                    ></i>
                  </span>
                  {/* <span
                    className="absolute top-0 left-0 p-1"
                    style={{
                      backgroundColor: "rgba(69, 167, 77, 0)",
                      marginTop: "-11px",
                      marginLeft: "752px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // لمنع انتشار الحدث للنقرات الأخرى
                      handleEditProduct(product, index); // استدعاء الدالة عند النقر
                    }}
                  >
                    <i
                      className="bi bi-pencil"
                      style={{
                        color: "rgba(255, 152, 19, 1)",
                        fontSize: "18px",
                      }}
                    ></i>
                  </span> */}
                </div>
              ))
            )}
            <div className="row mx-2">
              <div>
                {formItems.map((item, index) => (
                  <div key={index} className="row mb-3">
                    <Form.Group
                      className="mb-3 col-12 col-sm-3"
                      controlId={`formProduct${index}`}
                    >
                      <Select
                        value={options.find(
                          (option) => option.value === item.productId
                        )}
                        onChange={(selectedOption) => {
                          handleChange(
                            index,
                            "productId",
                            selectedOption.value
                          );
                        }}
                        options={options}
                        styles={customStyles}
                        placeholder={uiT("landing.step_select_product_title")}
                        isSearchable
                      />
                    </Form.Group>
                    <Form.Group
                      className="mb-3 col-12 col-sm-3"
                      controlId={`formQty${index}`}
                    >
                      <Form.Control
                        type="number"
                        placeholder={uiT("quantity")}
                        value={item.quantity || ""}
                        onChange={(e) =>
                          handleChange(
                            index,
                            "quantity",
                            parseInt(e.target.value)
                          )
                        }
                        className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                        required
                      />
                    </Form.Group>
                    <Form.Group
                      className="mb-3 col-12 col-sm-3"
                      controlId={`formTotal${index}`}
                    >
                      <Form.Control
                        type="number"
                        placeholder={uiT("services.price")}
                        value={item.price || ""}
                        onChange={(e) =>
                          handleChange(index, "price", parseInt(e.target.value))
                        }
                        className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                        required
                      />
                    </Form.Group>
                    <Form.Group
                      className="mb-3 col-12 col-sm-3"
                      controlId={`formoptions${index}`}
                    >
                      <Form.Control
                        type="text"
                        placeholder={uiT("orders.note")}
                        value={item.options.offer}
                        onChange={(e) =>
                          handleChange(index, "options.offer", e.target.value)
                        }
                        className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                      />
                    </Form.Group>
                  </div>
                ))}

                <div className="row">
                  <Button
                    onClick={addFormItem}
                    variant="outline-primary"
                    className="ant-btn text-white css-dev-only-do-not-override-19gw05y ant-btn-primary ant-btn-lg hp-bg-warning-1 hp-border-color-warning-1 hp-hover-bg-warning-2 hp-hover-border-color-warning-2"
                  >
                    {uiT("orderDetails.orderForm.addProduct")}
                  </Button>
                </div>
              </div>
            </div>
            <p className="text-center text-white fr-b">
              <b>{uiT("FormSettings.customer_info.title")}</b>
            </p>
            <div className="row mx-2">
              <Form.Group
                className="mb-3 col-12 col-sm-4"
                controlId="formBasicEmail"
              >
                <Form.Control
                  type="text"
                  placeholder={uiT("name")}
                  value={dataForm.name}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, name: e.target.value })
                  }
                  className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                />
              </Form.Group>
              <Form.Group
                className="mb-3 col-12 col-sm-4"
                controlId="formBasicPhone"
              >
                <Form.Control
                  type="text"
                  placeholder={uiT("phone")}
                  value={dataForm?.isValid ? "********" : dataForm.phone} // Show asterisks if dataForm.isValid is true
                  onChange={(e) => {
                    if (!dataForm?.isValid) {
                      // Only allow changes if dataForm.isValid is false
                      setDataForm({ ...dataForm, phone: e.target.value });
                    }
                  }}
                  className={`w-full inline-flex items-center justify-between text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-purple-400 focus:ring-2 ${
                    dataForm?.isValid ? "border-red-500" : ""
                  }`}
                  disabled={dataForm?.isValid} // Disable input if either isValid is true
                />
              </Form.Group>

              <Form.Group
                className="mb-3 col-12 col-sm-4"
                controlId="formBasicAddress"
              >
                <Form.Control
                  type="text"
                  placeholder={uiT("ui.email")}
                  value={dataForm.email}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, email: e.target.value })
                  }
                  className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                />
              </Form.Group>
              <Form.Group
                className="mb-3 col-12 col-sm-4"
                controlId="formBasicAddress"
              >
                <Form.Control
                  type="text"
                  placeholder={uiT("orderDetails.orderForm.orderNotePlaceholder")}
                  value={dataForm.note}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, note: e.target.value })
                  }
                  className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                />
              </Form.Group>

              <Form.Group
                className="mb-3 col-12 col-sm-6"
                controlId="formBasicTotalPrice"
              >
                <Form.Control
                  type="text"
                  placeholder={uiT("orderDetails.orderForm.totalPricePlaceholder")}
                  value={dataForm.total || ""}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, total: e.target.value })
                  }
                  className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                />
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              variant="secondary"
              onClick={() => {
                setLgShow(false);
                setFormItems([]);
              }}
              className="w-full mt-2 p-2.5 flex-1 text-gray-800 rounded-md outline-none border ring-offset-2 ring-indigo-600 focus:ring-2"
            >
              {uiT("video.close")}
            </button>
            <button
              type="submit"
              variant="primary"
              className="w-full mt-2 p-2.5 flex-1 text-white bg-[#9b59bf] rounded-md outline-none ring-offset-2 ring-indigo-600 focus:ring-2 "
            >
              {uiT("common.save")}
            </button>
          </Modal.Footer>
        </Form>
      )}
    </Modal>
  );
};

export default ModalAdd;
